import type { IconProps } from './typesIcons'

export function FaqMinusIcon({
  width = 24,
  height = 24,
  color = '#101010',
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 11.25H20V12.75H4V11.25Z"
        fill={color}
      />
    </svg>
  )
}
